import { Link } from "react-router-dom";
import { Reveal, Overline } from "@/components/Reveal";

const SHOWS = [
  {
    day: "Wednesday",
    name: "Let’s Elaborate",
    body: "Focused commentary and cultural analysis.",
    to: "/shows#lets-elaborate",
    testid: "two-shows-elaborate",
    className: "border-gold/30 bg-wine",
  },
  {
    day: "Saturday",
    name: "The Program",
    body: "The flagship multi-topic show, with Shi Sips.",
    to: "/shows#the-program",
    testid: "two-shows-program",
    className: "border-gold/30 bg-forest",
  },
];

export default function TwoShows() {
  return (
    <section data-testid="two-shows-section" className="py-28 md:py-36">
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <Reveal>
          <Overline>The Schedule</Overline>
          <h2 className="mt-4 font-display text-4xl font-black leading-[0.92] tracking-tight md:text-6xl">Week with <span className="italic text-gold">SHi.</span></h2>
        </Reveal>
        <div className="mt-14 grid gap-6 md:grid-cols-2">
          {SHOWS.map((show, index) => (
            <Reveal key={show.name} delay={index * 0.1}>
              <Link to={show.to} data-testid={show.testid} className={`group flex min-h-[22rem] flex-col justify-between rounded-3xl border p-8 transition-colors hover:border-gold md:p-12 ${show.className}`}>
                <div>
                  <p className="font-sans text-[11px] font-bold uppercase tracking-[0.34em] text-gold">{show.day}</p>
                  <h3 className="mt-4 font-display text-4xl font-black uppercase leading-[0.9] tracking-tight text-cream md:text-6xl">{show.name}</h3>
                  <p className="mt-6 max-w-sm font-editorial text-[1.35rem] italic leading-relaxed text-cream/90 md:text-2xl">{show.body}</p>
                </div>
                <span className="mt-10 font-sans text-xs font-bold uppercase tracking-[0.18em] text-gold transition-opacity group-hover:opacity-70">Explore {show.name} &rarr;</span>
              </Link>
            </Reveal>
          ))}
        </div>
        <p data-testid="week-with-shi-start-line" className="mt-8 max-w-3xl text-base leading-relaxed text-latte">Program 001 premieres Thursday, December 3, 2026. Let&rsquo;s Elaborate begins Wednesday, December 9, then lands every other Wednesday for its first six episodes. The Program begins Saturday, December 12.</p>
      </div>
    </section>
  );
}